module.exports = __webpack_public_path__ + "img/ico-check.3ffd15e7.svg";